//import this component froom dashboard folder
import MuscleDiagramCard from "../../../../dashboard/calendar/components/MuscleDiagramCard";

const WorkloadStats = () => (
  <article id="workload">
    <header>
      <h4>Workload by Muscle Group</h4>
      <p className="p4">(average for week)</p>
    </header>

    <MuscleDiagramCard isComposition={true} />
  </article>
);

export default WorkloadStats;
